import "src/css/widgets/widgets.css";

import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { useState, useEffect } from 'react';
import MonitorWSService from 'src/services/monitorwsservice';
import {
    Chart,
    Series,
    ArgumentAxis,
    CommonSeriesSettings,
    CommonAxisSettings,
    Grid,
    Export,
    Legend,
    Margin,
    Tooltip,
    Label,
    Format,
    Animation
} from 'devextreme-react/chart';
import WidgetSettings from "../widgetSettings";
import { selectionTypes } from "src/components/utils/consts";
import WidgetTools from "../widgetTools";

function SentimentByHour(props) {

    const { t } = useTranslation();
    const [interactions, setInteractions] = useState([]);
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [showSettings, setShowSettings] = useState(false);
    const [channel, setChannel] = useState(localStorage.getItem(`SentimentByHour_channel_${props.identifier}_user${props.id}`) || "");
    const [channelName, setChannelName] = useState(localStorage.getItem(`SentimentByHour_channelName_${props.identifier}_user${props.id}`) || "");
    const architectureSources = [
        { value: 'negative', name: t("negative"), color: "#f1416c" },
        { value: 'positive', name: t("positive"), color: "#50cd89" },
        { value: 'neutral', name: t("neutral"), color: "#b2b3bb" }
    ];
    useEffect(() => {
        // component mounts
        return () => {
            // component unmounts
            if (MonitorWSService?.stompClient?.connected) {
                MonitorWSService.stompClient.send("/app/unsubscribe/analysissentimentbyhour", {}, JSON.stringify({
                    token: props.token,
                }));

                MonitorWSService.stompClient.unsubscribe("analysissentimentbyhour");
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (props.connected) {
            let selectedGroups = JSON.parse(localStorage.getItem(`SentimentByHour_groups_${props.identifier}_user${props.id}`) || "[]");
            let channel = localStorage.getItem(`SentimentByHour_channel_${props.identifier}_user${props.id}`) || "";

            setSelectedGroups(selectedGroups);
            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/analysissentimentbyhour/`, function (callsbygroup) {
                if (localStorage.getItem("resizing") !== "true") {
                    let data = JSON.parse(callsbygroup.body);
                    let interactionsData = [];

                    for (let index = 0; index < data.total.length; index++) {
                        const total = data.total[index];
                        const positive = data.positive[index];
                        const negative = data.negative[index];
                        const neutral = data.neutral[index];
                        interactionsData.push({
                            hour: total.hour,
                            positive: positive.data,
                            negative: negative.data,
                            neutral: neutral.data
                        });
                    }

                    setInteractions(interactionsData);
                }
            }, { id: "analysissentimentbyhour" });

            MonitorWSService.stompClient.send("/app/subscribe/analysissentimentbyhour", {}, JSON.stringify({
                token: props.token,
                groupsIds: selectedGroups,
                channel: channel
            }));
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.connected]);

    const toggleSettings = () => {
        setShowSettings(!showSettings);
    };

    const closeWidget = (e) => {
        e.preventDefault();
        props.close(props.identifier);
    }


    const setGroupsAndChannel = (groups, channel, channelName) => {
        setShowSettings(!showSettings);
        setSelectedGroups(groups);
        localStorage.setItem(`SentimentByHour_groups_${props.identifier}_user${props.id}`, JSON.stringify(groups));

        setChannel(channel);
        setChannelName(channelName);
        localStorage.setItem(`SentimentByHour_channel_${props.identifier}_user${props.id}`, channel);
        localStorage.setItem(`SentimentByHour_channelName_${props.identifier}_user${props.id}`, channelName);

        MonitorWSService.stompClient.send("/app/subscribe/analysissentimentbyhour", {}, JSON.stringify({
            token: props.token,
            groupsIds: groups,
            channel: channel
        }));

    };

    return (

        <div className="card card-flush overflow-hidden h-lg-20 widget-container">
            <div className="card-header">
                <h3 className="card-title align-items-start flex-column text-primary drag-handle">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("clock-two")} /> {t("sentimentbyhour")}</span>
                </h3>
                <div className="card-toolbar" style={{ zIndex: 9999 }}>
                    <WidgetTools  key={`tools_${props.identifier}`}closeWidget={closeWidget} toggleSettings={toggleSettings}></WidgetTools>
                </div>
            </div>
            <div className="card-body" style={{ "padding": "0rem 2.25rem", height: "100%" }}>
                <Chart
                    palette="Violet"
                    dataSource={interactions}
                    height={"350px"}
                    rtlEnabled={props.rtl}
                >
                    <CommonSeriesSettings
                        argumentField="hour"
                        type="spline"
                    />
                    <CommonAxisSettings>
                        <Grid visible={true} />
                    </CommonAxisSettings>
                    {
                        architectureSources.map((item) => <Series
                            key={item.value}
                            valueField={item.value}
                            name={item.name}
                            color={item.color}
                        />)
                    }
                    <Margin bottom={20} />
                    <ArgumentAxis
                        allowDecimals={false}
                        axisDivisionFactor={60}
                    >
                        <Label
                            wordWrap="none"
                            overlappingBehavior={"rotate"}
                            rotationAngle={35}
                        >
                            <Format type="decimal" />
                        </Label>
                    </ArgumentAxis>
                    <Legend
                        verticalAlignment="left"
                        horizontalAlignment="center"
                        itemTextPosition="top"
                    />
                    <Export enabled={false} />
                    <Tooltip enabled={true} />
                    <Animation
                        enabled={false}
                    />
                </Chart>
            </div>
            <WidgetSettings key={`settings_${props.identifier}`}showSettings={showSettings} toggleSettings={toggleSettings} token={props.token} setGroupsAndChannel={setGroupsAndChannel} groups={selectedGroups} selectionType={selectionTypes.MESSAGESQUEUE} channel={channel} channelName={channelName}></WidgetSettings>
        </div>

    )
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        connected: state.parameters.connected,
        id: state.supervisor.id,
        rtl: state.parameters.rtl
    };
};

export default connect(mapStateToProps, {})(SentimentByHour);